import { useEffect, useState } from "react";
import { HeadingCustom } from "../atoms/HeadingCustom";
import { ParagraphCustom } from "../atoms/ParagraphCustom";
import { truncateTextByWords } from "../../utils/truncateTextByWords";


export const ContentCustom = ({ data, type }) => {
    const [isExtend, setIsExtend] = useState(false);
    const [isMaxWords, setIsMaxWords] = useState(25);

    useEffect(() => {
        if (!isExtend) return setIsMaxWords(25);

        setIsMaxWords(1000);
    }, [isMaxWords, isExtend]);

    const handleClickExtend = () => {
        setIsExtend(!isExtend);
    }

    return (
        <div className="absolute bottom-10 left-1/2 tranform -translate-x-1/2 h-auto z-20 w-10/12">
            <HeadingCustom size="small" className="text-slate-200 font-normal">{type === "actus" ? data?.title : data.bigTitle}</HeadingCustom>

            <div>
                {type === "actus" ? 
                
                    <div
                        className="text-slate-300"
                        dangerouslySetInnerHTML={{
                            __html: truncateTextByWords(data?.content, isMaxWords) 
                        }}
                    />
                    :
                    <ParagraphCustom size="small" className="text-slate-300">
                        {truncateTextByWords(data?.resume, isMaxWords)} 
                    </ParagraphCustom>
                }

                <button 
                    className="underline text-slate-400 text-xs hover:text-slate-500 cursor-pointer"
                    onClick={ handleClickExtend }
                > { isExtend ? "Fermer" : "Lire la suite" }</button>
            </div>
            
            
        </div>
    )
}